<div *ngIf="1==1">
  <div class="p-0 w-100 d-flex align-items-center justify-content-center rounded-3">
    <div class="card p-0 m-0 shadow-none w-100" style="max-width: 560px"  style="background-color: rgba(0,0,0,0)"  >
      <img [src]="emptyImage" class="card-img" alt="empty">
      <div class="card-img-overlay p-0">
      </div>
    </div>
  </div>
</div>
